import React, { useState } from 'react';

export default function RWA() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="page-content fade-up">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <span className="section-label">Real World Assets</span>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Tokenized Assets</div>
        </div>
        <button className="btn btn-primary btn-sm">+ Tokenize Asset</button>
      </div>

      {/* NCD Card */}
      <div className="rwa-card" onClick={() => setExpanded(!expanded)}>
        <div className="rwa-icon">🏦</div>
        <div>
          <div className="rwa-name">Sovereign Reserve NCD</div>
          <div className="rwa-meta">NCD-001 · Tier-1 Bank · 5yr · 5% APY · Dual Oracle Verified</div>
        </div>
        <div>
          <div className="rwa-amount">$100,000,000</div>
          <div className="rwa-status">● Dual Attested {expanded ? '▲' : '▼'}</div>
        </div>
      </div>

      {/* Expanded Detail */}
      {expanded && (
        <div className="card fade-up" style={{ marginBottom: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
            <div>
              <span className="section-label">Asset Details</span>
              <div className="data-row"><span className="data-label">Face Value</span><span className="data-value gold">$100,000,000</span></div>
              <div className="data-row"><span className="data-label">Issuing Bank</span><span className="data-value">Tier-1 EU Bank</span></div>
              <div className="data-row"><span className="data-label">Interest Rate</span><span className="data-value green">5.00% APY</span></div>
              <div className="data-row"><span className="data-label">Maturity</span><span className="data-value">2031-05-30</span></div>
              <div className="data-row"><span className="data-label">Yield Destination</span><span className="data-value gold">Community Pool</span></div>
              <div className="data-row"><span className="data-label">Token Supply</span><span className="data-value">100,000,000</span></div>
              <div className="data-row"><span className="data-label">Yield / year</span><span className="data-value green">$5,000,000</span></div>
            </div>
            <div>
              <span className="section-label">Oracle Attestations</span>
              <div style={{
                background: 'var(--off-black)',
                border: '1px solid var(--border)',
                borderRadius: 12,
                padding: 16,
              }}>
                <div className="data-row" style={{ paddingBottom: 12, borderBottom: '1px solid var(--border)' }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>Chainlink PoR</div>
                    <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>External attestation</div>
                  </div>
                  <span className="badge badge-green">✓ Confirmed</span>
                </div>
                <div className="data-row" style={{ paddingBottom: 12, borderBottom: '1px solid var(--border)', paddingTop: 12 }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>Amitis Validators</div>
                    <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>18 / 21 confirmed</div>
                  </div>
                  <span className="badge badge-green">✓ Confirmed</span>
                </div>
                <div className="data-row" style={{ paddingTop: 12 }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--blue)' }}>Dual Attestation</div>
                    <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>Both sources agree</div>
                  </div>
                  <span className="badge badge-blue">⬡ Verified</span>
                </div>
                <div style={{ marginTop: 12, fontFamily: 'DM Mono, monospace', fontSize: 10, color: 'var(--dimmer)', borderTop: '1px solid var(--border)', paddingTop: 12 }}>
                  Last confirmed: 2026-05-30 14:22 UTC<br />
                  Next scheduled: 2026-06-06 14:00 UTC<br />
                  Discrepancies: 0 (all-time)
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 20, paddingTop: 20, borderTop: '1px solid var(--border)' }}>
            <button className="btn btn-gold btn-sm">Add Liquidity</button>
            <button className="btn btn-outline btn-sm">View Pool →</button>
            <button className="btn btn-outline btn-sm" style={{ marginLeft: 'auto' }}>Explorer ↗</button>
          </div>
        </div>
      )}

      {/* Placeholder */}
      <div style={{
        background: 'var(--card-bg)',
        border: '1px dashed var(--border)',
        borderRadius: 14,
        padding: '28px 20px',
        textAlign: 'center',
        color: 'var(--dimmer)',
        fontSize: 13,
      }}>
        <div style={{ fontSize: 24, marginBottom: 8 }}>+</div>
        <div style={{ fontWeight: 600, color: 'var(--muted)', marginBottom: 4 }}>Tokenize a New Asset</div>
        <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 10 }}>
          Submit a governance proposal to tokenize any real-world asset on Amitis
        </div>
        <button className="btn btn-outline btn-sm" style={{ marginTop: 14 }}>Submit Proposal →</button>
      </div>
    </div>
  );
}
